// extracted by mini-css-extract-plugin
module.exports = {"ItemText":"sidebar-menu-item-with-icon_ItemText__loJeC","Active":"sidebar-menu-item-with-icon_Active__h8JMh"};